import { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import api from 'core/services/api';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isloggedIn = useSelector((state) => state.authorization.isloggedIn);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isloggedIn) {
      dispatch(api.util.resetApiState());
    }
  }, [dispatch, isloggedIn]);

  const CurrentComponent = isloggedIn ? (
    <Component />
  ) : (
    <Redirect to="/sign-in" />
  );
  return <Route {...rest} render={() => CurrentComponent} />;
};

export default PrivateRoute;
